class Wishlist {
  constructor() {
    this.STORAGE_KEY = 'rootweave_wishlist';
    this.wishlist = this.getWishlist();
    this.init();
  }

  getWishlist() {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  saveWishlist() {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.wishlist));
    this.updateCount();
    this.updateButtons();
  }

  add(handle) {
    if (!this.wishlist.includes(handle)) {
      this.wishlist.push(handle);
      this.saveWishlist();
    }
  }

  remove(handle) {
    this.wishlist = this.wishlist.filter(h => h !== handle);
    this.saveWishlist();
    
    // If on wishlist page, remove the card immediately
    const card = document.querySelector(`[data-wishlist-handle="${handle}"]`);
    if (card) {
      card.remove();
      this.checkEmptyState();
    }
  }
  
  toggle(handle) {
    if (this.wishlist.includes(handle)) {
      this.remove(handle);
    } else {
      this.add(handle);
    }
  }

  updateCount() {
    const countElements = document.querySelectorAll('.wishlist-count');
    countElements.forEach(el => {
      el.textContent = this.wishlist.length;
    });
  }
  
  updateButtons() {
    const buttons = document.querySelectorAll('.wishlist-btn');
    buttons.forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (this.wishlist.includes(handle)) {
        btn.classList.add('wishlist-btn--active');
      } else {
        btn.classList.remove('wishlist-btn--active');
      }
    });
  }

  init() {
    this.updateCount();
    
    // Delegate events for wishlist buttons
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.wishlist-btn');
      if (btn) {
        e.preventDefault();
        const handle = btn.dataset.productHandle;
        if (handle) {
          this.toggle(handle);
        }
      }
    });
    
    // Initialize initial button states after a short delay to ensure DOM is ready
    setTimeout(() => this.updateButtons(), 100);

    // If on the wishlist page, load the products
    const params = new URLSearchParams(window.location.search);
    if (window.location.pathname === '/search' && params.get('view') === 'wishlist') {
      this.loadWishlistPage();
    }
  }

  checkEmptyState() {
    const grid = document.getElementById('wishlist-grid');
    const emptyState = document.getElementById('wishlist-empty');
    if (this.wishlist.length === 0) {
      if (grid) grid.style.display = 'none';
      if (emptyState) emptyState.style.display = 'block';
    } else {
      if (grid) grid.style.display = 'flex';
      if (emptyState) emptyState.style.display = 'none';
    }
  }

  async loadWishlistPage() {
    const grid = document.getElementById('wishlist-grid');
    const loader = document.getElementById('wishlist-loading');
    
    this.checkEmptyState();

    if (this.wishlist.length === 0) {
      if (loader) loader.style.display = 'none';
      return;
    }

    try {
      const promises = this.wishlist.map(handle => 
        fetch(`${window.Shopify.routes.root}search?q=handle:${handle}&type=product&section_id=main-search`)
          .then(res => res.text())
      );

      const results = await Promise.all(promises);
      
      let html = '';
      results.forEach((responseText, index) => {
        const handle = this.wishlist[index];
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, 'text/html');
        const gridItem = doc.querySelector('.grid__item');
        
        if (gridItem) {
          // Add data attribute to identify the card for removal
          gridItem.setAttribute('data-wishlist-handle', handle);
          html += gridItem.outerHTML;
        }
      });

      if (grid) grid.innerHTML = html;
      
      // Update buttons inside the newly loaded cards
      this.updateButtons();
      
    } catch (error) {
      console.error('Error loading wishlist items:', error);
    } finally {
      if (loader) loader.style.display = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.WishlistApp = new Wishlist();
});
